import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      isolate: false
    }),
  ],
  exports: [TranslateModule],
})
export class TranslationModule {

  static forRoot(): ModuleWithProviders<TranslationModule> {
    return {
      ngModule: TranslationModule,
    };
  }

  static forChild(): ModuleWithProviders<any> {
    return TranslateModule.forChild();
  }

  constructor(translate: TranslateService) {
    const lang = localStorage.getItem('lang');
    
    if (localStorage.getItem('lang') != null) {
      translate.setDefaultLang(localStorage.getItem('lang'));
    } else {
      translate.setDefaultLang('fr');
    }
  }
}
